module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.steps) ? _c('div', {
    staticClass: "progressbar-wrapper"
  }, [_c('ul', {
    staticClass: "progressbar"
  }, _vm._l((_vm.steps), function(step, i) {
    return _c('li', {
      key: i,
      staticClass: "item",
      class: {
        active: _vm.active >= i + 1
      }
    }, [_c('span', {
      staticClass: "step"
    }, [_vm._v(_vm._s(step))])])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98fe16cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressStep.vue
// module id = 1211
// module chunks = 0